!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.GoogleLogin = t(require("react")) : e.GoogleLogin = t(e.react);
}("undefined" != typeof self ? self : this, function (e) {
  return o = {}, t.m = n = [function (t) {
    t.exports = e;
  }, function (e, t, n) {
    e.exports = n(2)();
  }, function (e, t, n) {
    "use strict";

    function o() {}

    function r() {}

    var i = n(3);
    r.resetWarningCache = o, e.exports = function () {
      function e(e, t, n, o, r, a) {
        if (a !== i) {
          var c = Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw c.name = "Invariant Violation", c;
        }
      }

      function t() {
        return e;
      }

      var n = {
        array: e.isRequired = e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: r,
        resetWarningCache: o
      };
      return n.PropTypes = n;
    };
  }, function (e) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    "use strict";

    function o(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
          var n = [],
              o = !0,
              r = !1,
              i = void 0;

          try {
            for (var a, c = e[Symbol.iterator](); !(o = (a = c.next()).done) && (n.push(a.value), !t || n.length !== t); o = !0) {
              ;
            }
          } catch (e) {
            r = !0, i = e;
          } finally {
            try {
              o || null == c.return || c.return();
            } finally {
              if (r) throw i;
            }
          }

          return n;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return r(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(n) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? r(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function r(e, t) {
      null != t && t <= e.length || (t = e.length);

      for (var n = 0, o = Array(t); n < t; n++) {
        o[n] = e[n];
      }

      return o;
    }

    function i(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
          var n = [],
              o = !0,
              r = !1,
              i = void 0;

          try {
            for (var a, c = e[Symbol.iterator](); !(o = (a = c.next()).done) && (n.push(a.value), !t || n.length !== t); o = !0) {
              ;
            }
          } catch (e) {
            r = !0, i = e;
          } finally {
            try {
              o || null == c.return || c.return();
            } finally {
              if (r) throw i;
            }
          }

          return n;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return a(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(n) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? a(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function a(e, t) {
      null != t && t <= e.length || (t = e.length);

      for (var n = 0, o = Array(t); n < t; n++) {
        o[n] = e[n];
      }

      return o;
    }

    function c(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
          var n = [],
              o = !0,
              r = !1,
              i = void 0;

          try {
            for (var a, c = e[Symbol.iterator](); !(o = (a = c.next()).done) && (n.push(a.value), !t || n.length !== t); o = !0) {
              ;
            }
          } catch (e) {
            r = !0, i = e;
          } finally {
            try {
              o || null == c.return || c.return();
            } finally {
              if (r) throw i;
            }
          }

          return n;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return u(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(n) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? u(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function u(e, t) {
      null != t && t <= e.length || (t = e.length);

      for (var n = 0, o = Array(t); n < t; n++) {
        o[n] = e[n];
      }

      return o;
    }

    function l(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
          var n = [],
              o = !0,
              r = !1,
              i = void 0;

          try {
            for (var a, c = e[Symbol.iterator](); !(o = (a = c.next()).done) && (n.push(a.value), !t || n.length !== t); o = !0) {
              ;
            }
          } catch (e) {
            r = !0, i = e;
          } finally {
            try {
              o || null == c.return || c.return();
            } finally {
              if (r) throw i;
            }
          }

          return n;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return s(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(n) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? s(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function s(e, t) {
      null != t && t <= e.length || (t = e.length);

      for (var n = 0, o = Array(t); n < t; n++) {
        o[n] = e[n];
      }

      return o;
    }

    function f(e, t, n, o, r, i) {
      var a = e.getElementsByTagName(t)[0],
          c = a,
          u = a;
      (u = e.createElement(t)).id = n, u.src = o, c && c.parentNode ? c.parentNode.insertBefore(u, c) : e.head.appendChild(u), u.onerror = i, u.onload = r;
    }

    function d(e, t) {
      var n = e.getElementById(t);
      n && n.parentNode.removeChild(n);
    }

    function p(e) {
      return b.a.createElement("span", {
        style: {
          paddingRight: 10,
          fontWeight: 500,
          paddingLeft: e.icon ? 0 : 10,
          paddingTop: 10,
          paddingBottom: 10
        }
      }, e.children);
    }

    function g(e) {
      return b.a.createElement("div", {
        style: {
          marginRight: 10,
          background: e.active ? "#eee" : "#fff",
          padding: 10,
          borderRadius: 2
        }
      }, b.a.createElement("svg", {
        width: "18",
        height: "18",
        xmlns: "http://www.w3.org/2000/svg"
      }, b.a.createElement("g", {
        fill: "#000",
        fillRule: "evenodd"
      }, b.a.createElement("path", {
        d: "M9 3.48c1.69 0 2.83.73 3.48 1.34l2.54-2.48C13.46.89 11.43 0 9 0 5.48 0 2.44 2.02.96 4.96l2.91 2.26C4.6 5.05 6.62 3.48 9 3.48z",
        fill: "#EA4335"
      }), b.a.createElement("path", {
        d: "M17.64 9.2c0-.74-.06-1.28-.19-1.84H9v3.34h4.96c-.1.83-.64 2.08-1.84 2.92l2.84 2.2c1.7-1.57 2.68-3.88 2.68-6.62z",
        fill: "#4285F4"
      }), b.a.createElement("path", {
        d: "M3.88 10.78A5.54 5.54 0 0 1 3.58 9c0-.62.11-1.22.29-1.78L.96 4.96A9.008 9.008 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.92-2.26z",
        fill: "#FBBC05"
      }), b.a.createElement("path", {
        d: "M9 18c2.43 0 4.47-.8 5.96-2.18l-2.84-2.2c-.76.53-1.78.9-3.12.9-2.38 0-4.4-1.57-5.12-3.74L.97 13.04C2.45 15.98 5.48 18 9 18z",
        fill: "#34A853"
      }), b.a.createElement("path", {
        fill: "none",
        d: "M0 0h18v18H0z"
      }))));
    }

    function y(e) {
      var t = i(Object(m.useState)(!1), 2),
          n = t[0],
          o = t[1],
          r = i(Object(m.useState)(!1), 2),
          a = r[0],
          c = r[1],
          u = e.tag,
          l = e.type,
          s = e.className,
          f = e.disabledStyle,
          d = e.buttonText,
          y = e.children,
          v = e.render,
          S = e.theme,
          j = e.icon,
          O = e.disabled,
          x = h({
        onSuccess: e.onSuccess,
        onAutoLoadFinished: e.onAutoLoadFinished,
        onRequest: e.onRequest,
        onFailure: e.onFailure,
        onScriptLoadFailure: e.onScriptLoadFailure,
        clientId: e.clientId,
        cookiePolicy: e.cookiePolicy,
        loginHint: e.loginHint,
        hostedDomain: e.hostedDomain,
        autoLoad: e.autoLoad,
        isSignedIn: e.isSignedIn,
        fetchBasicProfile: e.fetchBasicProfile,
        redirectUri: e.redirectUri,
        discoveryDocs: e.discoveryDocs,
        uxMode: e.uxMode,
        scope: e.scope,
        accessType: e.accessType,
        responseType: e.responseType,
        jsSrc: e.jsSrc,
        prompt: e.prompt
      }),
          I = x.signIn,
          w = O || !x.loaded;
      if (v) return v({
        onClick: I,
        disabled: w
      });

      var k = {
        backgroundColor: "dark" === S ? "rgb(66, 133, 244)" : "#fff",
        display: "inline-flex",
        alignItems: "center",
        color: "dark" === S ? "#fff" : "rgba(0, 0, 0, .54)",
        boxShadow: "0 2px 2px 0 rgba(0, 0, 0, .24), 0 0 1px 0 rgba(0, 0, 0, .24)",
        padding: 0,
        borderRadius: 2,
        border: "1px solid transparent",
        fontSize: 14,
        fontWeight: "500",
        fontFamily: "Roboto, sans-serif"
      },
          A = {
        cursor: "pointer",
        backgroundColor: "dark" === S ? "#3367D6" : "#eee",
        color: "dark" === S ? "#fff" : "rgba(0, 0, 0, .54)",
        opacity: 1
      },
          _ = w ? Object.assign({}, k, f) : a ? Object.assign({}, k, A) : n ? Object.assign({}, k, {
        cursor: "pointer",
        opacity: .9
      }) : k;

      return b.a.createElement(u, {
        onMouseEnter: function onMouseEnter() {
          return o(!0);
        },
        onMouseLeave: function onMouseLeave() {
          o(!1), c(!1);
        },
        onMouseDown: function onMouseDown() {
          return c(!0);
        },
        onMouseUp: function onMouseUp() {
          return c(!1);
        },
        onClick: I,
        style: _,
        type: l,
        disabled: w,
        className: s
      }, [j && b.a.createElement(g, {
        key: 1,
        active: a
      }), b.a.createElement(p, {
        icon: j,
        key: 2
      }, y || d)]);
    }

    n.r(t), n.d(t, "default", function () {
      return S;
    }), n.d(t, "GoogleLogin", function () {
      return S;
    }), n.d(t, "GoogleLogout", function () {
      return O;
    }), n.d(t, "useGoogleLogin", function () {
      return h;
    }), n.d(t, "useGoogleLogout", function () {
      return j;
    });
    var m = n(0),
        b = n.n(m),
        h = (n(1), function (e) {
      function t(e) {
        var t = e.getBasicProfile(),
            n = e.getAuthResponse(!0);
        e.googleId = t.getId(), e.tokenObj = n, e.tokenId = n.id_token, e.accessToken = n.access_token, e.profileObj = {
          googleId: t.getId(),
          imageUrl: t.getImageUrl(),
          email: t.getEmail(),
          name: t.getName(),
          givenName: t.getGivenName(),
          familyName: t.getFamilyName()
        }, i(e);
      }

      function n(e) {
        if (e && e.preventDefault(), P) {
          var n = window.gapi.auth2.getAuthInstance(),
              o = {
            prompt: L
          };
          p(), "code" === _ ? n.grantOfflineAccess(o).then(function (e) {
            return i(e);
          }, function (e) {
            return l(e);
          }) : n.signIn(o).then(function (e) {
            return t(e);
          }, function (e) {
            return l(e);
          });
        }
      }

      var r = e.onSuccess,
          i = void 0 === r ? function () {} : r,
          a = e.onAutoLoadFinished,
          c = void 0 === a ? function () {} : a,
          u = e.onFailure,
          l = void 0 === u ? function () {} : u,
          s = e.onRequest,
          p = void 0 === s ? function () {} : s,
          g = e.onScriptLoadFailure,
          y = e.clientId,
          b = e.cookiePolicy,
          h = e.loginHint,
          v = e.hostedDomain,
          S = e.autoLoad,
          j = e.isSignedIn,
          O = e.fetchBasicProfile,
          x = e.redirectUri,
          I = e.discoveryDocs,
          w = e.uxMode,
          k = e.scope,
          A = e.accessType,
          _ = e.responseType,
          E = e.jsSrc,
          T = void 0 === E ? "https://apis.google.com/js/api.js" : E,
          L = e.prompt,
          M = o(Object(m.useState)(!1), 2),
          P = M[0],
          C = M[1];
      return Object(m.useEffect)(function () {
        var e = !1,
            n = g || l;
        return f(document, "script", "google-login", T, function () {
          var o = {
            client_id: y,
            cookie_policy: b,
            login_hint: h,
            hosted_domain: v,
            fetch_basic_profile: O,
            discoveryDocs: I,
            ux_mode: w,
            redirect_uri: x,
            scope: k,
            access_type: A
          };
          "code" === _ && (o.access_type = "offline"), window.gapi.load("auth2", function () {
            var r = window.gapi.auth2.getAuthInstance();
            r ? r.then(function () {
              e || (j && r.isSignedIn.get() ? (C(!0), c(!0), t(r.currentUser.get())) : (C(!0), c(!1)));
            }, function (e) {
              l(e);
            }) : window.gapi.auth2.init(o).then(function (n) {
              if (!e) {
                C(!0);
                var o = j && n.isSignedIn.get();
                c(o), o && t(n.currentUser.get());
              }
            }, function (e) {
              C(!0), c(!1), n(e);
            });
          });
        }, function (e) {
          n(e);
        }), function () {
          e = !0, d(document, "google-login");
        };
      }, []), Object(m.useEffect)(function () {
        S && n();
      }, [P]), {
        signIn: n,
        loaded: P
      };
    });

    function v(e) {
      var t = l(Object(m.useState)(!1), 2),
          n = t[0],
          o = t[1],
          r = l(Object(m.useState)(!1), 2),
          i = r[0],
          a = r[1],
          c = e.tag,
          u = e.type,
          s = e.className,
          f = e.disabledStyle,
          d = e.buttonText,
          y = e.children,
          h = e.render,
          v = e.theme,
          S = e.icon,
          O = e.disabled,
          x = j({
        jsSrc: e.jsSrc,
        onFailure: e.onFailure,
        onScriptLoadFailure: e.onScriptLoadFailure,
        clientId: e.clientId,
        cookiePolicy: e.cookiePolicy,
        loginHint: e.loginHint,
        hostedDomain: e.hostedDomain,
        fetchBasicProfile: e.fetchBasicProfile,
        discoveryDocs: e.discoveryDocs,
        uxMode: e.uxMode,
        redirectUri: e.redirectUri,
        scope: e.scope,
        accessType: e.accessType,
        onLogoutSuccess: e.onLogoutSuccess
      }),
          I = x.signOut,
          w = O || !x.loaded;
      if (h) return h({
        onClick: I,
        disabled: w
      });

      var k = {
        backgroundColor: "dark" === v ? "rgb(66, 133, 244)" : "#fff",
        display: "inline-flex",
        alignItems: "center",
        color: "dark" === v ? "#fff" : "rgba(0, 0, 0, .54)",
        boxShadow: "0 2px 2px 0 rgba(0, 0, 0, .24), 0 0 1px 0 rgba(0, 0, 0, .24)",
        padding: 0,
        borderRadius: 2,
        border: "1px solid transparent",
        fontSize: 14,
        fontWeight: "500",
        fontFamily: "Roboto, sans-serif"
      },
          A = {
        cursor: "pointer",
        backgroundColor: "dark" === v ? "#3367D6" : "#eee",
        color: "dark" === v ? "#fff" : "rgba(0, 0, 0, .54)",
        opacity: 1
      },
          _ = w ? Object.assign({}, k, f) : i ? Object.assign({}, k, A) : n ? Object.assign({}, k, {
        cursor: "pointer",
        opacity: .9
      }) : k;

      return b.a.createElement(c, {
        onMouseEnter: function onMouseEnter() {
          return o(!0);
        },
        onMouseLeave: function onMouseLeave() {
          o(!1), a(!1);
        },
        onMouseDown: function onMouseDown() {
          return a(!0);
        },
        onMouseUp: function onMouseUp() {
          return a(!1);
        },
        onClick: I,
        style: _,
        type: u,
        disabled: w,
        className: s
      }, [S && b.a.createElement(g, {
        key: 1,
        active: i
      }), b.a.createElement(p, {
        icon: S,
        key: 2
      }, y || d)]);
    }

    y.defaultProps = {
      type: "button",
      tag: "button",
      buttonText: "Sign in with Google",
      scope: "profile email",
      accessType: "online",
      prompt: "",
      cookiePolicy: "single_host_origin",
      fetchBasicProfile: !0,
      isSignedIn: !1,
      uxMode: "popup",
      disabledStyle: {
        opacity: .6
      },
      icon: !0,
      theme: "light",
      onRequest: function onRequest() {}
    };

    var S = y,
        j = function j(e) {
      var t = e.jsSrc,
          n = void 0 === t ? "https://apis.google.com/js/api.js" : t,
          o = e.onFailure,
          r = e.onScriptLoadFailure,
          i = e.clientId,
          a = e.cookiePolicy,
          u = e.loginHint,
          l = e.hostedDomain,
          s = e.fetchBasicProfile,
          p = e.discoveryDocs,
          g = e.uxMode,
          y = e.redirectUri,
          b = e.scope,
          h = e.accessType,
          v = e.onLogoutSuccess,
          S = c(Object(m.useState)(!1), 2),
          j = S[0],
          O = S[1],
          x = Object(m.useCallback)(function () {
        if (window.gapi) {
          var e = window.gapi.auth2.getAuthInstance();
          null != e && e.then(function () {
            e.signOut().then(function () {
              e.disconnect(), v();
            });
          }, function (e) {
            return o(e);
          });
        }
      }, [v]);
      return Object(m.useEffect)(function () {
        var e = r || o;
        return f(document, "script", "google-login", n, function () {
          var t = {
            client_id: i,
            cookie_policy: a,
            login_hint: u,
            hosted_domain: l,
            fetch_basic_profile: s,
            discoveryDocs: p,
            ux_mode: g,
            redirect_uri: y,
            scope: b,
            access_type: h
          };
          window.gapi.load("auth2", function () {
            window.gapi.auth2.getAuthInstance() ? O(!0) : window.gapi.auth2.init(t).then(function () {
              return O(!0);
            }, function (t) {
              return e(t);
            });
          });
        }, function (t) {
          e(t);
        }), function () {
          d(document, "google-login");
        };
      }, []), {
        signOut: x,
        loaded: j
      };
    };

    v.defaultProps = {
      type: "button",
      tag: "button",
      buttonText: "Logout of Google",
      disabledStyle: {
        opacity: .6
      },
      icon: !0,
      theme: "light",
      jsSrc: "https://apis.google.com/js/api.js"
    };
    var O = v;
  }], t.c = o, t.d = function (e, n, o) {
    t.o(e, n) || Object.defineProperty(e, n, {
      enumerable: !0,
      get: o
    });
  }, t.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, t.t = function (e, n) {
    if (1 & n && (e = t(e)), 8 & n) return e;
    if (4 & n && "object" == typeof e && e && e.__esModule) return e;
    var o = Object.create(null);
    if (t.r(o), Object.defineProperty(o, "default", {
      enumerable: !0,
      value: e
    }), 2 & n && "string" != typeof e) for (var r in e) {
      t.d(o, r, function (t) {
        return e[t];
      }.bind(null, r));
    }
    return o;
  }, t.n = function (e) {
    var n = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return t.d(n, "a", n), n;
  }, t.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, t.p = "", t(t.s = 4);

  function t(e) {
    if (o[e]) return o[e].exports;
    var r = o[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return n[e].call(r.exports, r, r.exports, t), r.l = !0, r.exports;
  }

  var n, o;
});